export default class BlockGallery {
    constructor(containerSelector, options) {
        const defaultOptions = {
            splideSelector: '.splide',
            desktopSlider: true,
            mobileSlider: false,
            loaderEnabled: false,
            youtubeGalleryModal: '.youtube-gallery-modal',
            youtubeGalleryItemModal: '.gallery-item-modal',
            youtubeGalleryElement: '.plyr__video-embed',
            youtubeGalleryClose: 'svg.gallery-icon-modal-close',
            modalCloseContainer: '.modal-close-container',
        }

        this.options = Object.assign({}, defaultOptions, options)
        this.container = document.querySelector(containerSelector)

        if (!this.container) {
            return
        }

        this.youtubeGalleryModal = this.container.querySelector(this.youtubeGalleryModal)
        this.youtubeGalleryItemModal = this.container.querySelector(this.options.youtubeGalleryItemModal)
        this.youtubeGalleryElement = this.container.querySelector(this.options.youtubeGalleryElement)
        this.youtubeGalleryClose = this.container.querySelector(this.options.youtubeGalleryClose)
        this.modalCloseContainer = this.container.querySelector(this.options.modalCloseContainer)



        this.initSplide()
        this.initVideoModals()
    }

    initSplide() {
        this.splideElement = this.container.querySelector(this.options.splideSelector);
        if (this.splideElement) {
            new Splide(this.splideElement, {
                type: 'loop',
                drag: 'free',
                focus: 'center',
                perPage: 3,
                destroy: !this.options.desktopSlider,
                breakpoints: {
                    768: {
                        perPage: 1,
                        destroy: !this.options.mobileSlider
                    }
                },
                gap: '30px',
                pagination: true,
                autoScroll: { speed: 1 },
                pauseOnHover: true,
            }).mount(window.splide.Extensions)
        } else {
            console.warn("BlockGallery: Splide carousel element not found within the main container.");
        }
    }
    initVideoModals() {
        const videoSlides = this.container.querySelectorAll('.splide-slide')
        const youtubeGalleryModal = this.container.querySelector('.youtube-gallery-modal')
        const youtubeGalleryElementContainer = this.container.querySelector('.gallery-item-modal')
        const youtubeGalleryClose = this.container.querySelector(this.options.youtubeGalleryClose)
        const modalCloseContainer = this.container.querySelector(this.options.modalCloseContainer)

        let plyrInstance = null

        videoSlides.forEach(slide => {
            const modalOpenButton = slide.querySelector('a.gallery-modal-trigger')

            if (modalOpenButton !== null) {
                const youtubeId = modalOpenButton.dataset.youtubeId

                modalOpenButton.addEventListener('click', () => {
                    youtubeGalleryModal.style.display = 'flex'

                    if (plyrInstance) {
                        plyrInstance.destroy()
                        plyrInstance = null
                    }

                    youtubeGalleryElementContainer.innerHTML = `
                    <div class="plyr__video-embed video-plyr" data-plyr-provider="youtube" data-plyr-embed-id="${youtubeId}"></div>
                `

                    const newYoutubeGalleryElement = youtubeGalleryElementContainer.querySelector('.plyr__video-embed')

                    plyrInstance = new Plyr(newYoutubeGalleryElement, {
                        controls: ['play-large', 'play', 'progress', 'mute', 'fullscreen', 'volume'],
                        debug: false,
                        volume: 1,
                        autoplay: true
                    })

                    plyrInstance.on('ready', () => {
                        if (this.youtubeGalleryItemModal) this.youtubeGalleryItemModal.classList.add('active')
                        plyrInstance.play()
                    })
                })

                youtubeGalleryClose.addEventListener('click', () => {
                    if (plyrInstance) {
                        plyrInstance.stop()
                        plyrInstance.destroy()
                        plyrInstance = null
                    }
                    youtubeGalleryModal.style.display = 'none'
                    youtubeGalleryElementContainer.innerHTML = ''
                })
                  modalCloseContainer.addEventListener('click', () => {
                    if (plyrInstance) {
                        plyrInstance.stop()
                        plyrInstance.destroy()
                        plyrInstance = null
                    }
                    youtubeGalleryModal.style.display = 'none'
                    youtubeGalleryElementContainer.innerHTML = ''
                })
            }
        })
    }
}
